import { z } from 'zod';

/**
 * Schema for the ItemReference model.
 *
 * This is the SOURCE OF TRUTH for item-to-menu-group relationships.
 * Menu groups own the relationship via their items[] array.
 *
 * Supports:
 * - Item ordering within menu group (position)
 * - Required items for combos/deals (isRequired)
 * - Menu-specific price overrides (priceOverride)
 * - Visibility override per menu group (isHidden)
 * - Display name override per menu group (displayNameOverride)
 */
const ItemReferenceSchema = z.object({
  /** The ID of the referenced item */
  itemId: z.number().int({ message: "Item ID must be an integer" }).readonly(),
  /** Display position within this menu group (0-based) */
  position: z.number().int().default(0).readonly(),
  /** Whether this item is required (for combos/meal deals) */
  isRequired: z.boolean().default(false).readonly(),
  /** Price override for this item in this specific menu group (optional) */
  priceOverride: z.number().nonnegative().optional().readonly(),
  /** Hide this item in this specific menu group (optional) */
  isHidden: z.boolean().optional().readonly(),
  /** Optional display name override for this menu group context */
  displayNameOverride: z.string().optional().readonly(),
});

export type ItemReferenceType = z.infer<typeof ItemReferenceSchema>;

export default ItemReferenceSchema;
